import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./elements/Widget/Header/Wrapper.js